"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userInfoRule = exports.projectRule = void 0;
var projectRule = {
  game_name: [{
    required: true,
    trigger: 'blur',
    message: "\u8BF7\u8F93\u5165\u9879\u76EE\u540D\u79F0"
  }, {
    min: 1,
    max: 12,
    message: '请输入1-12位',
    trigger: 'blur'
  }, {
    whitespace: true,
    message: '只存在空格',
    trigger: 'blur'
  }],
  game_desc: [{
    required: true,
    trigger: 'blur',
    message: "\u8BF7\u8F93\u5165\u9879\u76EE\u63CF\u8FF0"
  }, {
    min: 1,
    max: 100,
    message: '请输入1-100位',
    trigger: 'blur'
  }, {
    whitespace: true,
    message: '只存在空格',
    trigger: 'blur'
  }],
  game_img: [{
    required: true,
    trigger: 'blur',
    message: "\u8BF7\u4E0A\u4F20\u56FE\u7247"
  }],
  root_cate: [{
    required: true,
    trigger: 'blur',
    message: "\u8BF7\u9009\u62E9\u9879\u76EE\u7C7B\u578B"
  }],
  second_cate: [{
    required: true,
    trigger: 'blur',
    message: "\u8BF7\u9009\u62E9\u9879\u76EE\u4E8C\u7EA7\u5206\u7C7B"
  }]
};
exports.projectRule = projectRule;
var userInfoRule = {
  email: [{
    required: true,
    trigger: 'blur',
    message: "\u8BF7\u8F93\u5165\u90AE\u7BB1"
  }, {
    type: 'email',
    message: '请输入正确的邮箱地址',
    trigger: 'blur'
  }],
  code: [{
    required: true,
    trigger: 'blur',
    message: "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801"
  }, {
    pattern: /^\d{6}$/,
    required: true,
    trigger: 'blur',
    message: '验证码输入格式错误'
  }]
};
exports.userInfoRule = userInfoRule;